import React from "react";
import ServiceBlock from "./components/ServiceBlock";
import "./components/Services.css";

/* IMPORT YOUR ICONS HERE */
import aiIcon from "../../assets/images/services/ai.png";
import marketingIcon from "../../assets/images/services/marketing.png";
import strategyIcon from "../../assets/images/services/strategy.png";
import researchIcon from "../../assets/images/services/research.png";
import digitalIcon from "../../assets/images/services/digital.png";
import cardBg from "../../assets/images/services/servicecard-bg.png";

const ServicesPage = () => {
  return (
    <section className="services-page">
      <div className="container">

        {/* HEADER */}
        <div className="services-header">
          <h1>Services</h1>
          <p>
            Our services are designed for businesses seeking sharper strategy,
            stronger market positioning, and more intelligent use of technology.
          </p>
        </div>

        {/* GRID */}
        <div className="services-grid">

          <ServiceBlock
            bgImage={cardBg}
            icon={aiIcon}
            title="AI Research & Consulting"
            description="We help clients explore and apply artificial intelligence in ways that are commercially relevant and operationally feasible."
            bullets={[
              "AI opportunity assessment",
              "AI use-case design",
              "Workflow and automation advisory",
              "Synthetic data / synthetic persona strategy",
              "AI roadmap development"
            ]}
          />

          <ServiceBlock
            bgImage={cardBg}
            icon={marketingIcon}
            title="Marketing Consultancy & Growth Strategy"
            description="We support brands and businesses with strategic marketing guidance that connects positioning, audience understanding, communications, and execution."
            bullets={[
              "Brand and market strategy",
              "Communications planning",
              "Digital content direction",
              "Media buying advisory",
              "Go-to-market planning"
            ]}
          />

          <ServiceBlock
            bgImage={cardBg}
            icon={strategyIcon}
            title="Strategic & Management Advisory"
            description="We work with founders, executives, and teams on strategic planning, business prioritization, and execution support."
            bullets={[
              "Business strategy development",
              "Strategic reviews & planning",
              "Project management support",
              "Management information structuring",
              "Leadership decision support"
            ]}
          />

          <ServiceBlock
            bgImage={cardBg}
            icon={researchIcon}
            title="Research, Insight & Analysis"
            description="We support business decisions through structured research, analysis, and interpretation."
            bullets={[
              "Market & category scans",
              "Consumer & stakeholder insights",
              "Public opinion analysis",
              "Statistical interpretation",
              "Decision-support research"
            ]}
          />

          <ServiceBlock
            bgImage={cardBg}
            icon={digitalIcon}
            title="Digital Content & Web Advisory"
            description="We help businesses shape stronger digital narratives and online presence."
            bullets={[
              "Website content architecture",
              "Digital messaging frameworks",
              "Content management support",
              "Thought-leadership structuring",
              "Brand presentation refinement"
            ]}
          />

        </div>
      </div>
    </section>
  );
};

export default ServicesPage;